import { ReactNode } from "react";
import { FirebaseProvider } from "./firebase";

export function NotificationProviders({ children }: { children: ReactNode }) {
  return <FirebaseProvider>{children}</FirebaseProvider>;
}
